export default __webpack_public_path__ + "static/leonardo-f29ffc9eb3463d58f14011105fe85f53.jpg";